import { fetchWithAuth } from '../utils/fetchWithAuth';

const API_URL = import.meta.env.VITE_API_URL;

export async function getChatbotConfig() {
  const r = await fetch(`${API_URL}/chatbot/config`, { method: 'GET' });
  if (!r.ok) throw new Error(await r.text());
  return r.json();
}

export async function updateChatbotConfig(enabled) {
  const r = await fetchWithAuth(`/admin/settings/chatbot`, {
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ enabled }),
  });
  if (!r.ok) throw new Error(await r.text());
  return r.json();
}
